export default {"src":"/_next/static/media/enthoumBg.b49777a8.svg","height":178,"width":1440};